import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=22837618"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22837618')) {
      api.createRecord('22837618', component.options)
    } else {
      api.reload('22837618', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=22837618", function () {
      api.rerender('22837618', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/footer/Footer.vue"
export default component.exports